import { render, staticRenderFns } from "./ApprovalsListView.vue?vue&type=template&id=36a23449&scoped=true"
import script from "./ApprovalsListView.vue?vue&type=script&lang=js"
export * from "./ApprovalsListView.vue?vue&type=script&lang=js"
import style0 from "./ApprovalsListView.vue?vue&type=style&index=0&id=36a23449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a23449",
  null
  
)

export default component.exports